import { RG_TYPE as r } from "@project-rouge/rg-core";
import { getRgObjectsAtLevel as t } from "../../../utils/rg-util/index3.js";
import { isSingleDoor as i } from "../../queries/index8.js";
const n = (o, e) => t(o, r.Door, e).filter(i).length;
export {
  n as getLevelSingleDoorsCount
};
//# sourceMappingURL=index33.js.map
